import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import WhatsappApiPricingContent from './WhatsappApiPricingContent';

const WhatsappApiPricing = () => (
  <>
    <Helmet>
      <title>WhatsApp API Pricing in India: Plans &amp; Costs | HAWKTRION</title>
      <meta name="description" content="Compare WhatsApp API plans in India and understand Meta messaging charges, platform costs, and integrations. Request a HAWKTRION pricing estimate." />
      <meta name="keywords" content="WhatsApp API pricing India, WhatsApp Business API plans, WhatsApp Cloud API costs" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-api-pricing/" />
      <meta property="og:title" content="WhatsApp API Pricing in India: Plans &amp; Costs | HAWKTRION" />
      <meta property="og:description" content="Compare WhatsApp API plans in India and understand Meta messaging charges, platform costs, and integrations. Request a HAWKTRION pricing estimate." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-api-pricing/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp API Pricing in India: Plans &amp; Costs | HAWKTRION" />
      <meta name="twitter:description" content="Compare WhatsApp API plans in India and understand Meta messaging charges, platform costs, and integrations. Request a HAWKTRION pricing estimate." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp API Pricing in India: Plans and Costs" hideCta>
      <WhatsappApiPricingContent />
    </SeoLandingPage>
  </>
);

export default WhatsappApiPricing;